/**
 * Creates an array of the own enumerable string-keyed property values from the `source` object.
 * @example
 * function Foo() {
 *   this.bar = 0;
 *   this.baz = 1;
 * }
 * Foo.prototype.qux = 2
 *
 * values(new Foo);
 * // => [0, 1]
 *
 * @function values
 * @param {Object} source The object to query.
 * @return {Array<*>} Returns an array of property values.
 */
export default function values(source) {
	const values = [];
	if (!source) return values;

	const entries = Object.entries(source);
	const {length: entriesLength} = entries;
	for (let i = 0; i < entriesLength; i++) values.push(entries[i][1]);

	return values;
}
